import React, { useState, useEffect } from 'react';
// STYLES
import styles from '../../../HoldingsTable/HoldingsTable.module.scss';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import CircularProgress from '@material-ui/core/CircularProgress';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// API
import { SEARCH_BIB_ITEMS_LOGGED, SEARCH_BIB_ITEMS_UNLOGGED } from './query';
// HOOKS
import { useLazyQuery } from '@apollo/client';
// UTILS
import jwt_decode from 'jwt-decode';
// COMPONENTS
import ItemsTableToggler from './ItemsTableToggler/ItemsTableToggler';
import ItemsTableHead from './ItemsTableHead/ItemsTableHead';
import ItemsTableBody from './ItemsTableBody/ItemsTableBody';

const ItemsTable = ({
  bibId,
  bib,
  me,
  setReservationData,
  setRequestData,
  items,
  count,
  periodicalType,
}) => {
  const [showTable, setShowTable] = useState(false);
  const accessToken =
    typeof window !== 'undefined' && window.sessionStorage
      ? sessionStorage.getItem('accessToken')
      : '';

  const [searchBibRecord, { data, loading }] = useLazyQuery(
    accessToken ? SEARCH_BIB_ITEMS_LOGGED : SEARCH_BIB_ITEMS_UNLOGGED
  );

  useEffect(() => {
    if (!bibId || !showTable) return;

    const variables = {
      searchType: 'record-guid',
      searchValue: bibId,
    };

    if (accessToken) {
      variables.calculatedItemPolicyForPatronWhere = {
        id: jwt_decode(accessToken).guid,
      };
    }

    searchBibRecord({
      variables,
    });
  }, [showTable]);

  const getTableContent = () => {
    if (!showTable) {
      return null;
    }

    const tableBody = loading ? (
      <TableBody>
        <TableRow>
          <TableCell colSpan={7} style={{ textAlign: 'center' }}>
            <CircularProgress />
          </TableCell>
        </TableRow>
      </TableBody>
    ) : (
      <ItemsTableBody
        itemData={
          data?.simpleSearchBibliographicsRecords_v2?.records?.[0]
            ?._physicalManifestations || []
        }
        me={me}
        setReservationData={setReservationData}
        setRequestData={setRequestData}
        periodicalType={periodicalType}
        bib={bib}
      />
    );

    return (
      <Box
        className={[
          styles.instanceListTableContainer,
          'instanceListTableContainer',
        ].join(' ')}
      >
        <Table
          stickyHeader
          className={[
            styles.instanceListTable,
            showTable ? styles.openTable : styles.closeTable,
          ].join(' ')}
        >
          <ItemsTableHead />
          {tableBody}
        </Table>
      </Box>
    );
  };

  return (
    <Box className={[styles.tableContainer, 'tableContainer'].join(' ')}>
      <ItemsTableToggler
        showTable={showTable}
        setShowTable={setShowTable}
        itemCount={count}
        me={me}
        setRequestData={setRequestData}
      />
      {getTableContent()}
    </Box>
  );
};

export default ItemsTable;
